var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import isIndividualKycComplete from 'utils/isKycComplete';
import * as statuses from '../../states';
import * as types from './types';
var initialState = {
    firstVisit: false,
    status: statuses.IDLE,
    kycs: [],
    user: {
        fullname: '',
    },
    isComplete: false,
    societies: [],
    step: [],
    bank: {
        status: statuses.IDLE,
    },
};
// eslint-disable-next-line default-param-last
export default function userReducer(state, actions) {
    if (state === void 0) { state = initialState; }
    var type = actions.type, payload = actions.payload;
    switch (type) {
        case types.FETCH_USER_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING, societyStatus: statuses.LOADING });
        case types.FETCH_USER_SUCCEED:
            return __assign(__assign(__assign({}, state), { status: statuses.SUCCESS }), payload);
        case types.FETCH_USER_FAIL:
            return __assign(__assign({}, state), { status: statuses.FAIL, error: payload });
        case types.CREATE_KYC_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING });
        case types.CREATE_KYC_SUCCEED:
            return __assign(__assign({}, state), { status: statuses.SUCCESS, kycs: __spreadArray(__spreadArray([], state.kycs, true), [
                    payload,
                ], false) });
        case types.CREATE_KYC_FAIL:
            return __assign(__assign({}, state), { status: statuses.FAIL, error: payload });
        case types.UPDATE_USER_VISIT:
            return __assign(__assign({}, state), { firstVisit: false });
        case types.UPDATE_INDIVIDUAL_KYC_REQUEST:
            return __assign(__assign({}, state), { update: statuses.LOADING });
        case types.UPDATE_INDIVIDUAL_KYC_SUCCESS:
            var p_1 = payload;
            return __assign(__assign(__assign(__assign({}, state), { update: statuses.SUCCESS, firstVisit: false }), payload), { kycs: state.kycs.map(function (kyc) { return ((kyc.type === 'individual_investor')
                    ? __assign(__assign(__assign({}, kyc), isIndividualKycComplete(__assign(__assign({}, state), p_1))), { isVerified: false }) : kyc); }) });
        case types.UPDATE_INDIVIDUAL_KYC_FAIL:
            return __assign(__assign({}, state), { update: statuses.IDLE });
        case types.UPDATE_BANK_REQUEST:
            return __assign(__assign({}, state), { update: statuses.LOADING });
        case types.UPDATE_BANK_SUCCESS:
            return __assign(__assign({}, state), { update: statuses.IDLE, bank: __assign(__assign({}, payload), { status: statuses.SUCCESS }) });
        case types.UPDATE_BANK_FAIL:
            return __assign(__assign({}, state), { update: statuses.IDLE });
        case types.UPDATE_USER_MODIFICATION_REQUEST:
            return __assign(__assign({}, state), { requestModification: payload });
        case types.FETCH_BANK_REQUEST:
            return __assign(__assign({}, state), { bank: __assign(__assign({}, state.bank), { status: statuses.LOADING }) });
        case types.FETCH_BANK_SUCCESS:
            return __assign(__assign({}, state), { bank: __assign(__assign(__assign({}, state.bank), { status: statuses.SUCCESS }), payload) });
        case types.UPDATE_USER_SOCIETY:
            if (!payload || !('value' in payload))
                return;
            return __assign(__assign({}, state), { kycs: state.kycs.map(function (kyc) { return ((kyc.id === payload.value.siren)
                    ? (__assign(__assign({}, kyc), { name: payload.value.legalName || payload.value.legal_name, status: payload.value.status }))
                    : kyc); }), societies: state.societies.map(function (society) { return ((society.siren === payload.value.siren)
                    ? payload.value
                    : society); }) });
        case types.ADD_USER_SOCIETY:
            return __assign(__assign({}, state), { kycs: __spreadArray(__spreadArray([], state.kycs, true), [
                    {
                        name: payload.legalName,
                        isComplete: false,
                        isVerified: false,
                    },
                ], false), societies: __spreadArray(__spreadArray([], state.societies, true), [
                    payload,
                ], false) });
        default:
            return state;
    }
}
